import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { isClient } from '@systemeio/util';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { breakpointQueries } from './constants/breakpoint-queries';
import { BreakpointsStateInterface } from './types/breakpoints-state';
import { getBreakpointsByServerDeviceType } from './utils/get-breakpoints-by-server-device-type';
import { getCurrentBreakpoints } from './utils/get-current-breakpoints';
const useMediaQuery = () => {
  const $ = _c(8);
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  let t0;
  if ($[0] !== metaDataFromServer?.serverDeviceType) {
    t0 = !isClient() ? getBreakpointsByServerDeviceType(metaDataFromServer?.serverDeviceType) : getCurrentBreakpoints();
    $[0] = metaDataFromServer?.serverDeviceType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initialBreakpoints = t0;
  let t1;
  if ($[2] !== initialBreakpoints) {
    t1 = () => initialBreakpoints;
    $[2] = initialBreakpoints;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [breakpoints, setBreakpoints] = useState(t1);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const currentBreakpoints = getCurrentBreakpoints();
      setBreakpoints(currentBreakpoints);
      const listeners = Object.entries(breakpointQueries).map(t4 => {
        const [key, query] = t4;
        const mediaQuery = window.matchMedia(query);
        const handler = e => setBreakpoints(prev => ({
          ...prev,
          [key]: e.matches
        }));
        mediaQuery.addEventListener("change", handler);
        return {
          mediaQuery,
          handler
        };
      });
      return () => listeners.forEach(_temp);
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== breakpoints) {
    t4 = {
      ...breakpoints
    };
    $[6] = breakpoints;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default useMediaQuery;
function _temp(t0) {
  const {
    mediaQuery: mediaQuery_0,
    handler: handler_0
  } = t0;
  return mediaQuery_0.removeEventListener("change", handler_0);
}